import { computed } from "mobx";

import Entity from "lib/models/Entity";

interface TagSource {
  id: number;
  name: string;
  isActive: boolean;
  majorId: number;
}

export default class Tag extends Entity<TagSource> {
  @computed
  get name(): string {
    return this.source.name;
  }

  @computed
  get isActive(): boolean {
    return this.source.isActive;
  }

  @computed
  get majorId(): number {
    return this.source.majorId;
  }
}

export type { TagSource };
